import PropTypes from 'prop-types';

const OutcomesSection = ({ 
  title, 
  highlightedText, 
  titleEnd,
  description, 
  cards,
//   backgroundColor = '#f7fafc'
}) => {
  return (
    <section className="py-16 md:py-20">
      <div className="container mx-auto px-4">
        {/* Header Section */}
        <div className="text-center mb-12 max-w-4xl mx-auto">
          <h2 className="  font-bold text-gray-800 mb-6">
            <span className=''>{title}{' '}</span>
            <span className='secondary-text'>
              {highlightedText}
            </span>
            <span className=''>{titleEnd && ` ${titleEnd}`}</span>
          </h2>
          <p className="   leading-relaxed">
            {description}
          </p>
        </div>

        {/* Cards Grid - Reduced width with side spacing */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8 max-w-5xl mx-auto px-4 md:px-8">
          {cards.map((card, index) => (
            <div
              key={index}
              className="bg-white rounded-lg overflow-hidden shadow-lg transition-all duration-300 ease-out hover:-translate-y-2 hover:shadow-2xl cursor-pointer"
            >
              {/* Card Header with Title and Bullets - Reduced padding */}
              <div
                className="p-5 md:p-6 text-white primary-bg"
              >
                <h3 className="  font-bold mb-4 border-b border-white/70">
                  {card.title}
                </h3>
                <ul className="space-y-2">
                  {card.benefits.map((benefit, idx) => (
                    <li key={idx} className="flex items-start text-xs md:">
                      <span className="mr-2 mt-0.5 flex-shrink-0 ">•</span>
                      <span className="leading-relaxed">{benefit}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Card Images - Side by Side - Reduced height */}
              <div className="grid grid-cols-2 h-36 md:h-44">
                <div className="overflow-hidden">
                  <img
                    src={card.image1}
                    alt={`${card.title} - Image 1`}
                    className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
                  />
                </div>
                <div className="overflow-hidden">
                  <img
                    src={card.image2}
                    alt={`${card.title} - Image 2`}
                    className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

OutcomesSection.propTypes = {
  title: PropTypes.string.isRequired,
  highlightedText: PropTypes.string.isRequired,
  titleEnd: PropTypes.string,
  description: PropTypes.string.isRequired,
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      benefits: PropTypes.arrayOf(PropTypes.string).isRequired,
      image1: PropTypes.string.isRequired,
      image2: PropTypes.string.isRequired,
    })
  ).isRequired,
  backgroundColor: PropTypes.string,
};

export default OutcomesSection;